module.exports = require('chaplin').mediator;
